import { LayersIndicatorsBusinessNameClass } from '@core/models/layers.model'

const pantagruel = 'pantagruel'

const cooling_need_2020_baseline = 'cooling_need_2020_baseline'
const cooling_need_2030_baseline = 'cooling_need_2030_baseline'
const cooling_need_2030_moderate_efficiency = 'cooling_need_2030_moderate_efficiency'
const cooling_need_2030_high_efficiency = 'cooling_need_2030_high_efficiency'
const cooling_need_2040_baseline = 'cooling_need_2040_baseline'
const cooling_need_2040_moderate_efficiency = 'cooling_need_2040_moderate_efficiency'
const cooling_need_2040_high_efficiency = 'cooling_need_2040_high_efficiency'
const cooling_need_2050_baseline = 'cooling_need_2050_baseline'
const cooling_need_2050_moderate_efficiency = 'cooling_need_2050_moderate_efficiency'
const cooling_need_2050_high_efficiency = 'cooling_need_2050_high_efficiency'

const heat_tot_curr_density = 'heat_tot_curr_density'
const cool_tot_curr_density = 'cool_tot_curr_density'
const gfa_tot_curr_density = 'gfa_tot_curr_density'
const gfa_res_curr_density = 'gfa_res_curr_density'
const gfa_nonres_curr_density = 'gfa_nonres_curr_density'
const ghs_built_1975_100_share = 'ghs_built_1975_100_share'
const ghs_built_1990_100_share = 'ghs_built_1990_100_share'
const ghs_built_2000_100_share = 'ghs_built_2000_100_share'
const ghs_built_2014_100_share = 'ghs_built_2014_100_share'
const potential_solarthermal_collectors_rooftop = 'potential_solarthermal_collectors_rooftop'
const potential_solarthermal_collectors_open_field = 'potential_solarthermal_collectors_open_field'
const heat_res_curr_density = 'heat_res_curr_density'
const heat_nonres_curr_density = 'heat_nonres_curr_density'
const solar_optimal_total = 'solar_optimal_total'
const vol_tot_curr_density = 'vol_tot_curr_density'
const vol_res_curr_density = 'vol_res_curr_density'
const vol_nonres_curr_density = 'vol_nonres_curr_density'

const pop_tot_curr_density = 'pop_tot_curr_density'
const pop_tot_density_2020 = 'pop_tot_density_2020'
const pop_tot_density_2030 = 'pop_tot_density_2030'
const pop_used_by_other_layer = pop_tot_density_2020
const info_pop_used_by_other_layers = ' (population 2020)'

const wwtp_capacity = 'wwtp_2015_csv'
const wwtp_power = 'wwtp_2015_csv'

const potential_forest = 'potential_forest'
const forest_residues_view = 'forest_residues'
const livestock_effluents_view = 'livestock_effluents'
const solid_waste = 'solid_waste'
const output_wind_speed = 'output_wind_speed'
const wind_50m = 'wind_50m'
const potential_potential_shallowgeothermal = 'shallow_geothermal_potential'
const hdd_curr = 'hdd_curr'
const cdd_curr = 'cdd_curr'
const land_surface_temperature = 'land_surface_temperature'

const motorization_rate = 'motorization_rate_nuts2'
const default_ev_density = 'default_ev_density'
const cs_density = 'cs_density'
const rasterized_iso_urban = 'rasterized_iso_urban'
const rasterized_iso_rural = 'rasterized_iso_rural'
const rasterized_border = 'rasterized_border'
const rasterized_urau = 'rasterized_urau'
const rasterized_urau_rural = 'rasterized_urau_rural'
const work_osm = 'work_osm'
const filtered_corine_land_cover = 'filtered_corine_land_cover'
const poi_osm = 'poi_osm'
const half_gravity = 'half_gravity'

const agricultural_residues_view = 'agricultural_residues'
const solar_radiation = 'solar_radiation'

const emissions_hourly_csv = 'emissions_hourly_csv'

const cities_with_geothermal_district_heating = 'cities_with_geothermal_district_heating'
const cities_with_district_heating = 'cities_with_district_heating'

const population_valais_2023 = 'population_2023'
const batteries_piles_quantite = 'batteries_piles_quantite'
const boues_de_step_quantite = 'boues_de_step_quantite'
const compostable_restaurant_organique_quantite = 'compostable_restaurant_organique_quantite'
const ordures_menageres = 'ordures_menageres'
const papier_et_carton_quantite = 'papier_et_carton_quantite'
const PET_quantite = 'pet_quantite'
const plastique_quantite = 'plastique_quantite'
const verre_quantite = 'verre_quantite'
const vieux_bois = 'vieux_bois'
const biowaste_interpolation = 'biowaste_interpolation'
const usines_transporteurs = 'usines_transporteurs'

const africa_pop_tot_density_2020 = 'africa_pop_tot_density_2020'
const africa_pop_tot_density_2025 = 'africa_pop_tot_density_2025'
const africa_pop_tot_density_2030 = 'africa_pop_tot_density_2030'
const africa_wind_50m = 'africa_wind_50m'
const africa_wind_100m = 'africa_wind_100m'
const africa_wind_200m = 'africa_wind_200m'
const africa_solar_potential = 'africa_solar_potential'
const electricity_transmission_and_distribution_mv_planned =
  'electricity_transmission_and_distribution_mv_planned'
const electricity_transmission_and_distribution_mv_existing =
  'electricity_transmission_and_distribution_mv_existing'
const electricity_transmission_and_distribution_hv_planned =
  'electricity_transmission_and_distribution_hv_planned'
const electricity_transmission_and_distribution_hv_existing =
  'electricity_transmission_and_distribution_hv_existing'
const electricity_transmission_and_distribution_lv_planned =
  'electricity_transmission_and_distribution_lv_planned'
const electricity_transmission_and_distribution_lv_existing =
  'electricity_transmission_and_distribution_lv_existing'
const small_mini_hydro_potential = 'small_mini_hydro_potential'
const africa_workplaces_osm = 'workplaces_osm'
const africa_points_of_interest_osm = 'points_of_interest_osm'
const africa_travel_time_to_cities = 'travel_time_to_cities'
const wind_speed_50m = 'wind_speed_50m'
const africa_global_horizontal_irradiation = 'africa_global_horizontal_irradiation'
const distribution_transformers = 'distribution_transformers'

const europeanLayers = [
  // Buildings

  {
    api_name: cool_tot_curr_density + '_consumption',
    business_name: 'Theoretical cooling needs total',
  },
  {
    api_name: cool_tot_curr_density + '_count_cell',
    business_name: 'Counted Cells',
  },
  {
    api_name: cool_tot_curr_density + '_consumption_min',
    business_name: 'Cooling density min',
  },
  {
    api_name: cool_tot_curr_density + '_consumption_max',
    business_name: 'Cooling density max',
  },
  {
    api_name: cool_tot_curr_density + '_density',
    business_name: 'Average cooling density',
  },
  {
    api_name:
      cool_tot_curr_density + '_' + cool_tot_curr_density + '_per_' + pop_used_by_other_layer,
    business_name: 'Theoretical cooling needs per person ' + info_pop_used_by_other_layers,
  },

  {
    api_name: cooling_need_2020_baseline + '_consumption',
    business_name: 'Theoretical cooling needs total',
  },
  {
    api_name: cooling_need_2020_baseline + '_count_cell',
    business_name: 'Counted Cells',
  },
  {
    api_name: cooling_need_2020_baseline + '_consumption_min',
    business_name: 'Cooling density min',
  },
  {
    api_name: cooling_need_2020_baseline + '_consumption_max',
    business_name: 'Cooling density max',
  },
  {
    api_name: cooling_need_2020_baseline + '_density',
    business_name: 'Average cooling density',
  },

  {
    api_name: cooling_need_2030_baseline + '_consumption',
    business_name: 'Theoretical cooling needs total',
  },
  {
    api_name: cooling_need_2030_baseline + '_count_cell',
    business_name: 'Counted Cells',
  },
  {
    api_name: cooling_need_2030_baseline + '_consumption_min',
    business_name: 'Cooling density min',
  },
  {
    api_name: cooling_need_2030_baseline + '_consumption_max',
    business_name: 'Cooling density max',
  },
  {
    api_name: cooling_need_2030_baseline + '_density',
    business_name: 'Average cooling density',
  },

  {
    api_name: cooling_need_2030_moderate_efficiency + '_consumption',
    business_name: 'Theoretical cooling needs total',
  },
  {
    api_name: cooling_need_2030_moderate_efficiency + '_count_cell',
    business_name: 'Counted Cells',
  },
  {
    api_name: cooling_need_2030_moderate_efficiency + '_consumption_min',
    business_name: 'Cooling density min',
  },
  {
    api_name: cooling_need_2030_moderate_efficiency + '_consumption_max',
    business_name: 'Cooling density max',
  },
  {
    api_name: cooling_need_2030_moderate_efficiency + '_density',
    business_name: 'Average cooling density',
  },

  {
    api_name: cooling_need_2030_high_efficiency + '_consumption',
    business_name: 'Theoretical cooling needs total',
  },
  {
    api_name: cooling_need_2030_high_efficiency + '_count_cell',
    business_name: 'Counted Cells',
  },
  {
    api_name: cooling_need_2030_high_efficiency + '_consumption_min',
    business_name: 'Cooling density min',
  },
  {
    api_name: cooling_need_2030_high_efficiency + '_consumption_max',
    business_name: 'Cooling density max',
  },
  {
    api_name: cooling_need_2030_high_efficiency + '_density',
    business_name: 'Average cooling density',
  },

  {
    api_name: cooling_need_2040_baseline + '_consumption',
    business_name: 'Theoretical cooling needs total',
  },
  {
    api_name: cooling_need_2040_baseline + '_count_cell',
    business_name: 'Counted Cells',
  },
  {
    api_name: cooling_need_2040_baseline + '_consumption_min',
    business_name: 'Cooling density min',
  },
  {
    api_name: cooling_need_2040_baseline + '_consumption_max',
    business_name: 'Cooling density max',
  },
  {
    api_name: cooling_need_2040_baseline + '_density',
    business_name: 'Average cooling density',
  },

  {
    api_name: cooling_need_2040_moderate_efficiency + '_consumption',
    business_name: 'Theoretical cooling needs total',
  },
  {
    api_name: cooling_need_2040_moderate_efficiency + '_count_cell',
    business_name: 'Counted Cells',
  },
  {
    api_name: cooling_need_2040_moderate_efficiency + '_consumption_min',
    business_name: 'Cooling density min',
  },
  {
    api_name: cooling_need_2040_moderate_efficiency + '_consumption_max',
    business_name: 'Cooling density max',
  },
  {
    api_name: cooling_need_2040_moderate_efficiency + '_density',
    business_name: 'Average cooling density',
  },

  {
    api_name: cooling_need_2040_high_efficiency + '_consumption',
    business_name: 'Theoretical cooling needs total',
  },
  {
    api_name: cooling_need_2040_high_efficiency + '_count_cell',
    business_name: 'Counted Cells',
  },
  {
    api_name: cooling_need_2040_high_efficiency + '_consumption_min',
    business_name: 'Cooling density min',
  },
  {
    api_name: cooling_need_2040_high_efficiency + '_consumption_max',
    business_name: 'Cooling density max',
  },
  {
    api_name: cooling_need_2040_high_efficiency + '_density',
    business_name: 'Average cooling density',
  },

  {
    api_name: cooling_need_2050_baseline + '_consumption',
    business_name: 'Theoretical cooling needs total',
  },
  {
    api_name: cooling_need_2050_baseline + '_count_cell',
    business_name: 'Counted Cells',
  },
  {
    api_name: cooling_need_2050_baseline + '_consumption_min',
    business_name: 'Cooling density min',
  },
  {
    api_name: cooling_need_2050_baseline + '_consumption_max',
    business_name: 'Cooling density max',
  },
  {
    api_name: cooling_need_2050_baseline + '_density',
    business_name: 'Average cooling density',
  },

  {
    api_name: cooling_need_2050_moderate_efficiency + '_consumption',
    business_name: 'Theoretical cooling needs total',
  },
  {
    api_name: cooling_need_2050_moderate_efficiency + '_count_cell',
    business_name: 'Counted Cells',
  },
  {
    api_name: cooling_need_2050_moderate_efficiency + '_consumption_min',
    business_name: 'Cooling density min',
  },
  {
    api_name: cooling_need_2050_moderate_efficiency + '_consumption_max',
    business_name: 'Cooling density max',
  },
  {
    api_name: cooling_need_2050_moderate_efficiency + '_density',
    business_name: 'Average cooling density',
  },

  {
    api_name: cooling_need_2050_high_efficiency + '_consumption',
    business_name: 'Theoretical cooling needs total',
  },
  {
    api_name: cooling_need_2050_high_efficiency + '_count_cell',
    business_name: 'Counted Cells',
  },
  {
    api_name: cooling_need_2050_high_efficiency + '_consumption_min',
    business_name: 'Cooling density min',
  },
  {
    api_name: cooling_need_2050_high_efficiency + '_consumption_max',
    business_name: 'Cooling density max',
  },
  {
    api_name: cooling_need_2050_high_efficiency + '_density',
    business_name: 'Average cooling density',
  },

  {
    api_name: heat_tot_curr_density + '_consumption',
    business_name: 'Heat demand total',
  },
  {
    api_name: heat_tot_curr_density + '_count_cell',
    business_name: 'Counted Cells',
  },
  {
    api_name: heat_tot_curr_density + '_consumption_min',
    business_name: 'Heat density min',
  },
  {
    api_name: heat_tot_curr_density + '_consumption_max',
    business_name: 'Heat density max',
  },
  {
    api_name: heat_tot_curr_density + '_density',
    business_name: 'Average heat density',
  },
  {
    api_name:
      heat_tot_curr_density + '_' + heat_tot_curr_density + '_per_' + pop_used_by_other_layer,
    business_name: 'Heat demand per person' + info_pop_used_by_other_layers,
  },

  {
    api_name: heat_res_curr_density + '_consumption',
    business_name: 'Heat demand total',
  },
  {
    api_name: heat_res_curr_density + '_count_cell',
    business_name: 'Counted Cells',
  },
  {
    api_name: heat_res_curr_density + '_density',
    business_name: 'Average heat density',
  },
  {
    api_name:
      heat_res_curr_density + '_' + heat_res_curr_density + '_per_' + pop_used_by_other_layer,
    business_name: 'Heat demand per person' + info_pop_used_by_other_layers,
  },

  {
    api_name: heat_nonres_curr_density + '_consumption',
    business_name: 'Heat demand total',
  },
  {
    api_name: heat_nonres_curr_density + '_count_cell',
    business_name: 'Counted Cells',
  },
  {
    api_name: heat_nonres_curr_density + '_density',
    business_name: 'Average heat density',
  },
  {
    api_name:
      heat_nonres_curr_density + '_' + heat_nonres_curr_density + '_per_' + pop_used_by_other_layer,
    business_name: 'Heat demand per person' + info_pop_used_by_other_layers,
  },

  ////////////////////////////////////////////////////////////////////////////////////////////////////////

  // Gross floor Area
  {
    api_name: gfa_tot_curr_density + '_total',
    business_name: 'Gross floor area',
  },
  {
    api_name: gfa_tot_curr_density + '_density',
    business_name: 'Gross floor area density',
  },
  {
    api_name: gfa_tot_curr_density + '_count_cell',
    business_name: 'Counted cells',
  },
  {
    api_name: gfa_tot_curr_density + '_' + gfa_tot_curr_density + '_per_' + pop_used_by_other_layer,
    business_name: 'GFA per person' + info_pop_used_by_other_layers,
  },

  {
    api_name: gfa_res_curr_density + '_total',
    business_name: 'Gross floor area',
  },
  {
    api_name: gfa_res_curr_density + '_density',
    business_name: 'Gross floor area density',
  },
  {
    api_name: gfa_res_curr_density + '_count_cell',
    business_name: 'Counted cells',
  },
  {
    api_name: gfa_res_curr_density + '_' + gfa_res_curr_density + '_per_' + pop_used_by_other_layer,
    business_name: 'GFA per person' + info_pop_used_by_other_layers,
  },

  {
    api_name: gfa_nonres_curr_density + '_total',
    business_name: 'Gross floor area',
  },
  {
    api_name: gfa_nonres_curr_density + '_density',
    business_name: 'Gross floor area density',
  },
  {
    api_name: gfa_nonres_curr_density + '_count_cell',
    business_name: 'Counted cells',
  },
  {
    api_name:
      gfa_nonres_curr_density + '_' + gfa_nonres_curr_density + '_per_' + pop_used_by_other_layer,
    business_name: 'GFA per person' + info_pop_used_by_other_layers,
  },

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  // Construction periods
  {
    api_name: ghs_built_1975_100_share + '_density',
    business_name: 'Average share of GFA in the construction period',
  },
  {
    api_name: ghs_built_1975_100_share + '_count_cell',
    business_name: 'Counted cells',
  },

  {
    api_name: ghs_built_1990_100_share + '_density',
    business_name: 'Average share of GFA in the construction period',
  },
  {
    api_name: ghs_built_1990_100_share + '_count_cell',
    business_name: 'Counted cells',
  },

  {
    api_name: ghs_built_2000_100_share + '_density',
    business_name: 'Average share of GFA in the construction period',
  },
  {
    api_name: ghs_built_2000_100_share + '_count_cell',
    business_name: 'Counted cells',
  },

  {
    api_name: ghs_built_2014_100_share + '_density',
    business_name: 'Average share of GFA in the construction period',
  },
  {
    api_name: ghs_built_2014_100_share + '_count_cell',
    business_name: 'Counted cells',
  },

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  // Building volume
  {
    api_name: vol_tot_curr_density + '_total',
    business_name: 'Building volume',
  },
  {
    api_name: vol_tot_curr_density + '_density',
    business_name: 'Building volume density',
  },
  {
    api_name: vol_tot_curr_density + '_count_cell',
    business_name: 'Counted cells',
  },
  {
    api_name: vol_tot_curr_density + '_' + vol_tot_curr_density + '_per_' + pop_used_by_other_layer,
    business_name: 'Building volume per person' + info_pop_used_by_other_layers,
  },

  {
    api_name: vol_res_curr_density + '_total',
    business_name: 'Building volume',
  },
  {
    api_name: vol_res_curr_density + '_density',
    business_name: 'Building volume density',
  },
  {
    api_name: vol_res_curr_density + '_count_cell',
    business_name: 'Counted cells',
  },
  {
    api_name: vol_res_curr_density + '_' + vol_res_curr_density + '_per_' + pop_used_by_other_layer,
    business_name: 'Building volume per person' + info_pop_used_by_other_layers,
  },

  {
    api_name: vol_nonres_curr_density + '_total',
    business_name: 'Building volume',
  },
  {
    api_name: vol_nonres_curr_density + '_density',
    business_name: 'Building volume density',
  },
  {
    api_name: vol_nonres_curr_density + '_count_cell',
    business_name: 'Counted cells',
  },
  {
    api_name:
      vol_nonres_curr_density + '_' + vol_nonres_curr_density + '_per_' + pop_used_by_other_layer,
    business_name: 'Building volume per person' + info_pop_used_by_other_layers,
  },

  ////////////////////////////////////////////////////////////////////////////////////////////////////////

  //Industry
  {
    api_name: 'industrial_database_emissions_value',
    business_name: 'CO₂ emissions of energy intensive industries',
  },
  {
    api_name: 'industrial_database_excess_heat_value0',
    business_name: 'excess heat potential [0°C - 50°C]',
  },
  {
    api_name: 'industrial_database_excess_heat_value4',
    business_name: 'excess heat potential [50°C - 100°C]',
  },
  {
    api_name: 'industrial_database_excess_heat_value1',
    business_name: 'excess heat potential [100°C - 200°C]',
  },
  {
    api_name: 'industrial_database_excess_heat_value2',
    business_name: 'excess heat potential [200°C - 500°C]',
  },
  {
    api_name: 'industrial_database_excess_heat_value3',
    business_name: 'excess heat potential [ > 500°C]',
  },
  {
    api_name: 'industrial_database_excess_heat_value5',
    business_name: 'ventilation',
  },
  {
    api_name: 'industrial_database_excess_heat_value6',
    business_name: 'business process',
  },
  {
    api_name: 'industrial_database_excess_heat_value7',
    business_name: 'lighting',
  },
  {
    api_name: 'industrial_database_excess_heat_value8',
    business_name: 'total',
  },
  {
    api_name: 'industrial_database_excess_heat_total',
    business_name: 'Total excess heat potential of energy-intensive industries',
  },

  {
    api_name: 'industrial_database_emissions_NominalPower',
    business_name: 'Nominal power',
  },

  ////////////////////////////////////////////////////////////////////////////////////////////////////////

  //Population
  {
    api_name: pop_tot_curr_density + '_population',
    business_name: 'Total population',
  },
  {
    api_name: pop_tot_curr_density + '_density',
    business_name: 'Average population density',
  },
  {
    api_name: pop_tot_curr_density + '_area_ha',
    business_name: 'Surface selected',
  },
  {
    api_name: pop_tot_density_2020 + '_population',
    business_name: 'Total population',
  },
  {
    api_name: pop_tot_density_2020 + '_density',
    business_name: 'Average population density',
  },
  {
    api_name: pop_tot_density_2020 + '_area_ha',
    business_name: 'Surface selected',
  },
  {
    api_name: population_valais_2023 + '_total',
    business_name: 'Population 2023',
  },
  {
    api_name: pop_tot_density_2030 + '_population',
    business_name: 'Total population',
  },
  {
    api_name: pop_tot_density_2030 + '_density',
    business_name: 'Average population density',
  },
  {
    api_name: pop_tot_density_2030 + '_area_ha',
    business_name: 'Surface selected',
  },

  ////////////////////////////////////////////////////////////////////////////////////////////////////////

  //Mobility

  // motorization rate
  {
    api_name: motorization_rate + '_value',
    business_name: 'NUTS2 average (not weighted by population)',
  },
  // ev density
  {
    api_name: default_ev_density + '_Total',
    business_name: 'Total density',
  },
  {
    api_name: default_ev_density + '_Minimum',
    business_name: 'Minimum density',
  },
  {
    api_name: default_ev_density + '_Maximum',
    business_name: 'Maximum density',
  },
  {
    api_name: default_ev_density + '_Mean',
    business_name: 'Average density',
  },
  {
    api_name: default_ev_density + '_' + default_ev_density + '_per_1000' + pop_used_by_other_layer,
    business_name: 'Density per person' + info_pop_used_by_other_layers,
  },
  // charging stations density
  {
    api_name: cs_density + '_Count',
    business_name: 'Count',
  },
  {
    api_name: cs_density + '_Mean',
    business_name: 'Average density',
  },
  {
    api_name: cs_density + '_' + cs_density + '_per_1000' + pop_used_by_other_layer,
    business_name: 'Density per person' + info_pop_used_by_other_layers,
  },
  {
    api_name: cs_density + '_' + cs_density + '_per_1000' + pop_used_by_other_layer,
    business_name: 'Density per person' + info_pop_used_by_other_layers,
  },
  // eurostats cities isochrones
  {
    api_name: rasterized_iso_urban + '_Total',
    business_name: 'Total',
  },
  {
    api_name: rasterized_iso_urban + '_Minimum',
    business_name: 'Minimum',
  },
  {
    api_name: rasterized_iso_urban + '_Maximum',
    business_name: 'Maximum',
  },
  {
    api_name: rasterized_iso_urban + '_Mean',
    business_name: 'Average',
  },
  // smaller cities isochrones
  {
    api_name: rasterized_iso_rural + '_Total',
    business_name: 'Total',
  },
  {
    api_name: rasterized_iso_rural + '_Minimum',
    business_name: 'Minimum',
  },
  {
    api_name: rasterized_iso_rural + '_Maximum',
    business_name: 'Maximum',
  },
  {
    api_name: rasterized_iso_rural + '_Mean',
    business_name: 'Average',
  },
  // transborder commuter ratio
  {
    api_name: rasterized_border + '_Mean',
    business_name: 'Average',
  },
  // eurostat cities id
  {
    api_name: rasterized_urau + '_Minimum',
    business_name: 'Minimum',
  },
  {
    api_name: rasterized_urau + '_Maximum',
    business_name: 'Maximum',
  },
  // smaller cities id
  {
    api_name: rasterized_urau_rural + '_Minimum',
    business_name: 'Minimum',
  },
  {
    api_name: rasterized_urau_rural + '_Maximum',
    business_name: 'Maximum',
  },
  // workplaces from openstreetmap
  {
    api_name: work_osm + '_Total',
    business_name: 'Total',
  },
  {
    api_name: work_osm + '_Minimum',
    business_name: 'Minimum',
  },
  {
    api_name: work_osm + '_Maximum',
    business_name: 'Maximum',
  },
  {
    api_name: work_osm + '_Mean',
    business_name: 'Average',
  },
  {
    api_name: work_osm + '_' + work_osm + '_per_1000' + pop_used_by_other_layer,
    business_name: 'Workplace per person' + info_pop_used_by_other_layers,
  },
  // working areas from corine land cover
  {
    api_name: filtered_corine_land_cover + '_Total',
    business_name: 'Total',
  },
  // point of interest
  {
    api_name: poi_osm + '_Total',
    business_name: 'Total',
  },
  {
    api_name: poi_osm + '_Minimum',
    business_name: 'Minimum',
  },
  {
    api_name: poi_osm + '_Maximum',
    business_name: 'Maximum',
  },
  {
    api_name: poi_osm + '_Mean',
    business_name: 'Average',
  },
  {
    api_name: poi_osm + '_' + poi_osm + '_per_1000' + pop_used_by_other_layer,
    business_name: 'POI per person' + info_pop_used_by_other_layers,
  },
  // VKT from gravity model
  {
    api_name: half_gravity + '_Minimum',
    business_name: 'Minimum',
  },
  {
    api_name: half_gravity + '_Maximum',
    business_name: 'Maximum',
  },
  {
    api_name: half_gravity + '_Mean',
    business_name: 'Average',
  },

  ////////////////////////////////////////////////////////////////////////////////////////////////////////

  //Potentials
  {
    api_name: wwtp_capacity + '_capacity_capacity',
    business_name: 'Waste water treatment capacity',
  },
  {
    api_name: wwtp_power + '_power_power',
    business_name: 'Average excess heat power from waste water treatment',
  },

  {
    api_name: solar_optimal_total + '_average',
    business_name: 'Average solar radiation',
  },
  {
    api_name: solar_optimal_total + '_min',
    business_name: 'Minimum solar radiation',
  },
  {
    api_name: solar_optimal_total + '_max',
    business_name: 'Maximum solar radiation',
  },
  {
    api_name: solar_optimal_total + '_cells',
    business_name: 'Counted cells',
  },

  {
    api_name: potential_solarthermal_collectors_rooftop + '_average',
    business_name: 'Average solar thermal potential - rooftop',
  },
  {
    api_name: potential_solarthermal_collectors_rooftop + '_min',
    business_name: 'Min solar thermal potential - rooftop',
  },
  {
    api_name: potential_solarthermal_collectors_rooftop + '_max',
    business_name: 'Max solar thermal potential - rooftop',
  },
  {
    api_name: potential_solarthermal_collectors_rooftop + '_cells',
    business_name: 'Counted cells',
  },
  {
    api_name: potential_solarthermal_collectors_rooftop + '_total',
    business_name: 'Total solar thermal potential - rooftop',
  },

  {
    api_name: potential_solarthermal_collectors_open_field + '_average',
    business_name: 'Average solar thermal potential - open field',
  },
  {
    api_name: potential_solarthermal_collectors_open_field + '_min',
    business_name: 'Min solar thermal potential - open field',
  },
  {
    api_name: potential_solarthermal_collectors_open_field + '_max',
    business_name: 'Max solar thermal potential - open field',
  },
  {
    api_name: potential_solarthermal_collectors_open_field + '_cells',
    business_name: 'Counted cells',
  },
  {
    api_name: potential_solarthermal_collectors_open_field + '_total',
    business_name: 'Total solar thermal potential - open field',
  },

  {
    api_name: wind_50m + '_average',
    business_name: 'Average wind speed',
  },
  { api_name: wind_50m + '_min', business_name: 'Minimum wind speed' },
  { api_name: wind_50m + '_max', business_name: 'Maximum wind speed' },
  { api_name: wind_50m + '_cells', business_name: 'Counted cells' },

  {
    api_name: potential_potential_shallowgeothermal + '_value',
    business_name: 'Average heat conductivity',
  },

  {
    api_name: solid_waste + '_value',
    business_name: 'Potential from Waste - maximum resolution: NUTS3',
  },

  {
    api_name: agricultural_residues_view + '_NUTS_potential',
    business_name: 'Potential from agricultural residues - maximum resolution: NUTS3',
  },
  //{ api_name: agricultural_residues_view + '_agriculture_pp', business_name: 'Potential from agricultural residues per capita'},

  {
    api_name: livestock_effluents_view + '_NUTS_potential',
    business_name: 'Potential from livestock effluents - maximum resolution: NUTS3',
  },
  //{ api_name: livestock_effluents_view + '_livestock_effluents_pp', business_name: 'Potential from livestock_effluents_view per capita'},

  {
    api_name: forest_residues_view + '_NUTS_potential',
    business_name: 'Potential from forest residues - maximum resolution: NUTS3',
  },
  //{ api_name: forest_residues_view + '_forest_residues_pp', business_name: 'Potential from forest_residues_view per capita'},

  {
    api_name: potential_forest + '_average',
    business_name: 'Average potential from forest resdiues',
  },
  {
    api_name: potential_forest + '_value',
    business_name: 'Potential from forest resdiues',
  },
  {
    api_name: potential_forest + '_cells',
    business_name: 'Counted cells',
  },

  /////////////////////////////////////////////////////////////////////////////////////////////////////////

  //Climate
  { api_name: cdd_curr + '_average', business_name: 'Average CDD' },
  { api_name: cdd_curr + '_max', business_name: 'Maximum CDD' },
  { api_name: cdd_curr + '_min', business_name: 'Minimum CDD' },
  { api_name: cdd_curr + '_cells', business_name: 'Counted cells' },

  { api_name: hdd_curr + '_average', business_name: 'Average HDD' },
  { api_name: hdd_curr + '_max', business_name: 'Maximum HDD' },
  { api_name: hdd_curr + '_min', business_name: 'Minimum HDD' },
  { api_name: hdd_curr + '_cells', business_name: 'Counted cells' },

  {
    api_name: land_surface_temperature + '_average',
    business_name: 'Average Temperature',
  },
  {
    api_name: land_surface_temperature + '_maximum',
    business_name: 'Maximum Temperature',
  },
  {
    api_name: land_surface_temperature + '_minimum',
    business_name: 'Minimum Temperature',
  },
  {
    api_name: land_surface_temperature + '_cells',
    business_name: 'Counted cells',
  },

  {
    api_name: solar_radiation + '_average',
    business_name: 'Average solar radiation',
  },
  {
    api_name: solar_radiation + '_min',
    business_name: 'Minimum solar radiation',
  },
  {
    api_name: solar_radiation + '_max',
    business_name: 'Maximum solar radiation',
  },
  {
    api_name: solar_radiation + '_cells',
    business_name: 'Counted cells',
  },
  {
    api_name: solar_radiation + '_total_radiation',
    business_name: 'Total radiation on surface',
  },

  {
    api_name: output_wind_speed + '_average',
    business_name: 'Average wind speed',
  },
  {
    api_name: output_wind_speed + '_min',
    business_name: 'Minimum wind speed',
  },
  {
    api_name: output_wind_speed + '_max',
    business_name: 'Maximum wind speed',
  },
  {
    api_name: output_wind_speed + '_cells',
    business_name: 'Counted cells',
  },

  /////////////////////////////////////////////////////////////////////////////////////////////////////////

  //Electricity
  {
    api_name: pantagruel + '_buses_population',
    business_name: 'Total population',
  },
  {
    api_name: pantagruel + '_buses_base_kv',
    business_name: 'Voltage',
  },
  {
    api_name: pantagruel + '_lines_avg_load_injected',
    business_name: 'Average of load injected',
  },
  {
    api_name: pantagruel + '_lines_load_injected',
    business_name: 'Load injected',
  },
  {
    api_name: pantagruel + '_lines_total_power',
    business_name: 'Total power',
  },
  {
    api_name: pantagruel + '_lines_thermal_rating',
    business_name: 'Thermal rating',
  },
  {
    api_name: pantagruel + '_lines_losses',
    business_name: 'Losses',
  },
  {
    api_name: pantagruel + '_lines_min_voltage',
    business_name: 'Min voltage',
  },
  {
    api_name: pantagruel + '_lines_max_voltage',
    business_name: 'Max voltage',
  },
  {
    api_name: pantagruel + '_gens_category',
    business_name: 'Categories',
  },
  {
    api_name: pantagruel + '_gens_type',
    business_name: 'Types',
  },
  {
    api_name: pantagruel + '_gens_production',
    business_name: 'Production',
  },
  {
    api_name: pantagruel + '_gens_production_max',
    business_name: 'Max production',
  },
  {
    api_name: pantagruel + '_gens_min_voltage',
    business_name: 'Min voltage',
  },
  {
    api_name: pantagruel + '_gens_max_voltage',
    business_name: 'Max voltage',
  },
  {
    api_name: pantagruel + '_transfos_avg_load_injected',
    business_name: 'Average of load injected',
  },
  {
    api_name: pantagruel + '_transfos_load_injected',
    business_name: 'Load injected',
  },
  {
    api_name: pantagruel + '_transfos_total_power',
    business_name: 'Total power',
  },
  {
    api_name: pantagruel + '_transfos_thermal_rating',
    business_name: 'Thermal rating',
  },
  {
    api_name: pantagruel + '_transfos_losses',
    business_name: 'Losses',
  },
  {
    api_name: pantagruel + '_transfos_voltage_from_bus',
    business_name: 'Voltage of "from bus"',
  },
  {
    api_name: pantagruel + '_transfos_voltage_to_bus',
    business_name: 'Voltage of "to bus"',
  },
  {
    api_name: pantagruel + '_transfos_min_voltage_from_bus',
    business_name: 'Min voltage (from bus)',
  },
  {
    api_name: pantagruel + '_transfos_max_voltage_from_bus',
    business_name: 'Max voltage (from bus)',
  },
  {
    api_name: pantagruel + '_transfos_min_voltage_to_bus',
    business_name: 'Min voltage (to bus)',
  },
  {
    api_name: pantagruel + '_transfos_max_voltage_to_bus',
    business_name: 'Max voltage (to bus)',
  },
  {
    api_name: pantagruel + '_loads_consumption',
    business_name: 'Consumption',
  },
  {
    api_name: pantagruel + '_loads_min_voltage',
    business_name: 'Min voltage',
  },
  {
    api_name: pantagruel + '_loads_max_voltage',
    business_name: 'Max voltage',
  },
  {
    api_name: pantagruel + '_loads_difference_gen_load',
    business_name: 'Energy excess (production - consumption)',
  },
  {
    api_name: emissions_hourly_csv + '_density',
    business_name: 'Average CO2 emissions on NUTS0',
  },

  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  // SAPHEA
  {
    api_name: cities_with_geothermal_district_heating + '_' + 'cap_sum',
    business_name: 'Sum of capacity',
  },
  {
    api_name: cities_with_geothermal_district_heating + '_' + 'cap_min',
    business_name: 'Min capacity',
  },
  {
    api_name: cities_with_geothermal_district_heating + '_' + 'cap_max',
    business_name: 'Max capacity',
  },
  {
    api_name: cities_with_geothermal_district_heating + '_' + 'cap_average',
    business_name: 'Average capacity',
  },
  {
    api_name: cities_with_geothermal_district_heating + '_' + 'cap_mean',
    business_name: 'Mean capacity',
  },
  {
    api_name: cities_with_geothermal_district_heating + '_' + 'ene_sum',
    business_name: 'Sum of annual Energy Used',
  },
  {
    api_name: cities_with_geothermal_district_heating + '_' + 'ene_min',
    business_name: 'Min annual Energy Used',
  },
  {
    api_name: cities_with_geothermal_district_heating + '_' + 'ene_max',
    business_name: 'Max annual Energy Used',
  },
  {
    api_name: cities_with_geothermal_district_heating + '_' + 'ene_average',
    business_name: 'Average annual Energy Used',
  },

  {
    api_name: cities_with_district_heating + '_' + 'pop_sum',
    business_name: 'Sum of population',
  },
  {
    api_name: cities_with_district_heating + '_' + 'pop_min',
    business_name: 'Min population',
  },
  {
    api_name: cities_with_district_heating + '_' + 'pop_max',
    business_name: 'Max population',
  },
  {
    api_name: cities_with_district_heating + '_' + 'pop_average',
    business_name: 'Average population',
  },
  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  //Déchets
  {
    api_name: batteries_piles_quantite + '_total',
    business_name: 'Quantity (2023)',
  },
  {
    api_name: batteries_piles_quantite + '_' + batteries_piles_quantite + '_per_population_2023',
    business_name: 'Quantity per capita (2023)',
  },
  {
    api_name:
      batteries_piles_quantite + '_' + batteries_piles_quantite + '_per_pop_tot_density_2030',
    business_name: 'Quantity per capita (2030)',
  },
  {
    api_name: boues_de_step_quantite + '_total',
    business_name: 'Quantity (2023)',
  },
  {
    api_name: boues_de_step_quantite + '_' + boues_de_step_quantite + '_per_population_2023',
    business_name: 'Quantity per capita (2023)',
  },
  {
    api_name: boues_de_step_quantite + '_' + boues_de_step_quantite + '_per_pop_tot_density_2030',
    business_name: 'Quantity per capita (2030)',
  },
  {
    api_name: biowaste_interpolation + '_total',
    business_name: 'Quantity (2023)',
  },
  {
    api_name: biowaste_interpolation + '_' + biowaste_interpolation + '_per_population_2023',
    business_name: 'Quantity per capita (2023)',
  },
  {
    api_name: biowaste_interpolation + '_' + biowaste_interpolation + '_per_pop_tot_density_2030',
    business_name: 'Quantity per capita (2030)',
  },
  {
    api_name: compostable_restaurant_organique_quantite + '_total',
    business_name: 'Quantity (2023)',
  },
  {
    api_name:
      compostable_restaurant_organique_quantite +
      '_' +
      compostable_restaurant_organique_quantite +
      '_per_population_2023',
    business_name: 'Quantity per capita (2023)',
  },
  {
    api_name:
      compostable_restaurant_organique_quantite +
      '_' +
      compostable_restaurant_organique_quantite +
      '_per_pop_tot_density_2030',
    business_name: 'Quantity per capita (2030)',
  },
  {
    api_name: ordures_menageres + '_quantity',
    business_name: 'Quantity (2023)',
  },
  {
    api_name: ordures_menageres + '_impact',
    business_name: 'Impact',
  },
  {
    api_name: ordures_menageres + '_potential',
    business_name: 'Energy potential',
  },
  {
    api_name: ordures_menageres + '_' + ordures_menageres + '_per_population_2023',
    business_name: 'Quantity per capita (2023)',
  },
  {
    api_name: ordures_menageres + '_' + ordures_menageres + '_per_pop_tot_density_2030',
    business_name: 'Quantity per capita (2030)',
  },
  {
    api_name: ordures_menageres + '_' + ordures_menageres + '_impact_per_pop_tot_density_2030',
    business_name: 'Impact per capita (2030)',
  },
  {
    api_name: ordures_menageres + '_' + ordures_menageres + '_potential_per_pop_tot_density_2030',
    business_name: 'Potential per capita (2030)',
  },
  {
    api_name: papier_et_carton_quantite + '_total',
    business_name: 'Quantity (2023)',
  },
  {
    api_name: papier_et_carton_quantite + '_' + papier_et_carton_quantite + '_per_population_2023',
    business_name: 'Quantity per capita (2023)',
  },
  {
    api_name:
      papier_et_carton_quantite + '_' + papier_et_carton_quantite + '_per_pop_tot_density_2030',
    business_name: 'Quantity per capita (2030)',
  },
  {
    api_name: PET_quantite + '_total',
    business_name: 'Quantity (2023)',
  },
  {
    api_name: PET_quantite + '_' + PET_quantite + '_per_population_2023',
    business_name: 'Quantity per capita (2023)',
  },
  {
    api_name: PET_quantite + '_' + PET_quantite + '_per_pop_tot_density_2030',
    business_name: 'Quantity per capita (2030)',
  },
  {
    api_name: plastique_quantite + '_total',
    business_name: 'Quantity (2023)',
  },
  {
    api_name: plastique_quantite + '_' + plastique_quantite + '_per_population_2023',
    business_name: 'Quantity per capita (2023)',
  },
  {
    api_name: plastique_quantite + '_' + plastique_quantite + '_per_pop_tot_density_2030',
    business_name: 'Quantity per capita (2030)',
  },
  {
    api_name: verre_quantite + '_total',
    business_name: 'Quantity (2023)',
  },
  {
    api_name: verre_quantite + '_' + verre_quantite + '_per_population_2023',
    business_name: 'Quantity per capita (2023)',
  },
  {
    api_name: verre_quantite + '_' + verre_quantite + '_per_pop_tot_density_2030',
    business_name: 'Quantity per capita (2030)',
  },
  {
    api_name: vieux_bois + '_quantity',
    business_name: 'Quantity (2023)',
  },
  {
    api_name: vieux_bois + '_impact',
    business_name: 'Impact',
  },
  {
    api_name: vieux_bois + '_potential',
    business_name: 'Energy potential',
  },
  {
    api_name: vieux_bois + '_' + vieux_bois + '_per_population_2023',
    business_name: 'Quantity per capita (2023)',
  },
  {
    api_name: vieux_bois + '_' + vieux_bois + '_per_pop_tot_density_2030',
    business_name: 'Quantity per capita (2030)',
  },
  {
    api_name: vieux_bois + '_' + vieux_bois + '_impact_per_pop_tot_density_2030',
    business_name: 'Impact per capita (2030)',
  },
  {
    api_name: vieux_bois + '_' + vieux_bois + '_potential_per_pop_tot_density_2030',
    business_name: 'Potential per capita (2030)',
  },
  {
    api_name: usines_transporteurs + '_' + 'anlagetyp_fr',
    business_name: 'Type of installation',
  },
  {
    api_name: usines_transporteurs + '_' + 'anlagebezeichnung',
    business_name: 'Name',
  },
  {
    api_name: usines_transporteurs + '_' + 'url_behoerde',
    business_name: 'URL',
  },
]

export const LAYERS_INDICATORS_BUSINESS_NAME: {
  [key: string]: LayersIndicatorsBusinessNameClass[]
} = {
  citiwatts: europeanLayers,
  CoolLIFE: europeanLayers,
  DechetsVS: europeanLayers,
  SAPHEA: europeanLayers,
  openMod4Africa: [
    //////////////////////
    // OM4A
    //////////////////////
    {
      api_name: africa_pop_tot_density_2020 + '_population',
      business_name: 'Total population',
    },
    {
      api_name: africa_pop_tot_density_2020 + '_density',
      business_name: 'Average population density',
    },
    {
      api_name: africa_pop_tot_density_2020 + '_area_ha',
      business_name: 'Surface selected',
    },
    {
      api_name: africa_pop_tot_density_2025 + '_population',
      business_name: 'Total population',
    },
    {
      api_name: africa_pop_tot_density_2025 + '_density',
      business_name: 'Average population density',
    },
    {
      api_name: africa_pop_tot_density_2025 + '_area_ha',
      business_name: 'Surface selected',
    },
    {
      api_name: africa_pop_tot_density_2030 + '_population',
      business_name: 'Total population',
    },
    {
      api_name: africa_pop_tot_density_2030 + '_density',
      business_name: 'Average population density',
    },
    {
      api_name: africa_pop_tot_density_2030 + '_area_ha',
      business_name: 'Surface selected',
    },

    { api_name: 'africa_settlement_clusters' + '_population', business_name: 'Population' },

    {
      api_name: africa_wind_50m + '_average',
      business_name: 'Average wind potential',
    },
    { api_name: africa_wind_50m + '_min', business_name: 'Minimum wind potential' },
    { api_name: africa_wind_50m + '_max', business_name: 'Maximum wind potential' },
    { api_name: africa_wind_50m + '_cells', business_name: 'Counted cells' },

    {
      api_name: africa_wind_100m + '_average',
      business_name: 'Average wind potential',
    },
    { api_name: africa_wind_100m + '_min', business_name: 'Minimum wind potential' },
    { api_name: africa_wind_100m + '_max', business_name: 'Maximum wind potential' },
    { api_name: africa_wind_100m + '_cells', business_name: 'Counted cells' },

    {
      api_name: africa_wind_200m + '_average',
      business_name: 'Average wind potential',
    },
    { api_name: africa_wind_200m + '_min', business_name: 'Minimum wind potential' },
    { api_name: africa_wind_200m + '_max', business_name: 'Maximum wind potential' },
    { api_name: africa_wind_200m + '_cells', business_name: 'Counted cells' },

    {
      api_name: africa_solar_potential + '_average',
      business_name: 'Average solar potential',
    },
    { api_name: africa_solar_potential + '_min', business_name: 'Minimum solar potential' },
    { api_name: africa_solar_potential + '_max', business_name: 'Maximum solar potential' },
    { api_name: africa_solar_potential + '_cells', business_name: 'Counted cells' },

    {
      api_name: africa_global_horizontal_irradiation + '_Sum',
      business_name: 'Sum of Horizontal Irradiation',
    },
    {
      api_name: africa_global_horizontal_irradiation + '_Min',
      business_name: 'Min Horizontal Irradiation',
    },
    {
      api_name: africa_global_horizontal_irradiation + '_Max',
      business_name: 'Max Horizontal Irradiation',
    },
    {
      api_name: africa_global_horizontal_irradiation + '_Mean',
      business_name: 'Mean of Horizontal Irradiation',
    },
    {
      api_name: africa_global_horizontal_irradiation + '_Cells',
      business_name: 'Counted Cells',
    },

    {
      api_name: small_mini_hydro_potential + '_avg_power',
      business_name: 'Average power',
    },
    {
      api_name: small_mini_hydro_potential + '_min_power',
      business_name: 'Minimum voltage',
    },
    {
      api_name: small_mini_hydro_potential + '_max_power',
      business_name: 'Maximum voltage',
    },
    {
      api_name: electricity_transmission_and_distribution_lv_existing + '_avg_voltage',
      business_name: 'Average voltage',
    },
    {
      api_name: electricity_transmission_and_distribution_lv_existing + '_min_voltage',
      business_name: 'Minimum voltage',
    },
    {
      api_name: electricity_transmission_and_distribution_lv_existing + '_max_voltage',
      business_name: 'Maximum voltage',
    },
    {
      api_name: electricity_transmission_and_distribution_lv_planned + '_avg_voltage',
      business_name: 'Average voltage',
    },
    {
      api_name: electricity_transmission_and_distribution_lv_planned + '_min_voltage',
      business_name: 'Minimum voltage',
    },
    {
      api_name: electricity_transmission_and_distribution_lv_planned + '_max_voltage',
      business_name: 'Maximum voltage',
    },
    {
      api_name: electricity_transmission_and_distribution_mv_planned + '_avg_voltage',
      business_name: 'Average voltage',
    },
    {
      api_name: electricity_transmission_and_distribution_mv_planned + '_min_voltage',
      business_name: 'Minimum voltage',
    },
    {
      api_name: electricity_transmission_and_distribution_mv_planned + '_max_voltage',
      business_name: 'Maximum voltage',
    },
    {
      api_name: electricity_transmission_and_distribution_mv_existing + '_avg_voltage',
      business_name: 'Average voltage',
    },
    {
      api_name: electricity_transmission_and_distribution_mv_existing + '_min_voltage',
      business_name: 'Minimum voltage',
    },
    {
      api_name: electricity_transmission_and_distribution_mv_existing + '_max_voltage',
      business_name: 'Maximum voltage',
    },
    {
      api_name: electricity_transmission_and_distribution_hv_planned + '_avg_voltage',
      business_name: 'Average voltage',
    },
    {
      api_name: electricity_transmission_and_distribution_hv_planned + '_min_voltage',
      business_name: 'Minimum voltage',
    },
    {
      api_name: electricity_transmission_and_distribution_hv_planned + '_max_voltage',
      business_name: 'Maximum voltage',
    },
    {
      api_name: electricity_transmission_and_distribution_hv_existing + '_avg_voltage',
      business_name: 'Average voltage',
    },
    {
      api_name: electricity_transmission_and_distribution_hv_existing + '_min_voltage',
      business_name: 'Minimum voltage',
    },
    {
      api_name: electricity_transmission_and_distribution_hv_existing + '_max_voltage',
      business_name: 'Maximum voltage',
    },
    {
      api_name: africa_workplaces_osm + '_Total',
      business_name: 'Sum of workplaces',
    },
    {
      api_name: africa_points_of_interest_osm + '_Total',
      business_name: 'Sum of POI',
    },
    {
      api_name: africa_travel_time_to_cities + '_Minimum',
      business_name: 'Minimum travel time (min)',
    },
    {
      api_name: africa_travel_time_to_cities + '_Maximum',
      business_name: 'Maximum travel time (min)',
    },
    {
      api_name: africa_travel_time_to_cities + '_Mean',
      business_name: 'Mean travel time (min)',
    },
    {
      api_name: wind_speed_50m + '_Mean',
      business_name: 'Mean wind speed (m/s)',
    },
    {
      api_name: wind_speed_50m + '_Minimum',
      business_name: 'Minimum wind speed (m/s)',
    },
    {
      api_name: wind_speed_50m + '_Maximum',
      business_name: 'Maximum wind speed (m/s)',
    },
    {
      api_name: 'localities_powered_by_minigrids_geom',
      business_name: 'Amount of localities powered by minigrids',
    },
    {
      api_name: distribution_transformers + '_geom',
      business_name: 'Amount of distribution transformers',
    },
  ],
}
